type HeaderColumn = {
  id: string;
  title: string;
};

type BodyColumn = {
  id: string;
  value: string;
};

type Section<T> = Record<string, T[]>;

export const OfficeAccountingTableHeader: Section<HeaderColumn>[] = [
  {
    studentInfo: [
      { id: "id", title: "ID" },
      { id: "fullNameEn", title: "Full Name (English)" },
      { id: "country", title: "Country" },
      { id: "dateOfBirth", title: "Date of Birth" },
      { id: "passportNumber", title: "Passport №" },
      { id: "passportExpiryDate", title: "Passport Expiry Date" },
      { id: "studentPhone", title: "Student’s Contact Phone Number" },
      { id: "studentEmail", title: "Student’s Email" },
      { id: "managerEmail", title: "Manager’s Email" },
      { id: "agentEmail", title: "Agent’s Email" },
      { id: "fieldOfStudy", title: "Field of Study" },
      { id: "admissionSemester", title: "Admission Semester" },
      { id: "intake", title: "Intake" },
      { id: "currentSemester", title: "Current Semester" },
      { id: "expelled", title: "Expelled" },
      { id: "groupNumber", title: "Group №" },
      { id: "residencePermit", title: "Residence Permit" },
      { id: "residencePermitExpiry", title: "Residence Permit Expiry Date" },
    ],
  },
  {
    documents: [
      { id: "preparatoryOrder", title: "Preparatory Department Order (№, date)" },
      { id: "preparatoryExpel", title: "Expelled from Preparatory Department" },
      { id: "mainCourseEnrollmentOrder", title: "Main Course Enrollment Order (№, date)" },
      { id: "mainCourseExpel", title: "Expelled from Main Course" },
    ],
  },
  {
    invoice: [
      { id: "invoiceNumberDate", title: "INVOICE № / Date" },
      { id: "invoice", title: "Invoice" },
      { id: "invoiceCurrency", title: "Invoice Currency" },
      { id: "invoiceDurationYears", title: "Duration (Years, according to invoice)" },
      { id: "period1", title: "Period 1" },
    ],
  },
  {
    finance: [
      { id: "totalFeeAccrued", title: "Total Fee Accrued up to Current Semester" },
      { id: "totalPaidCurrentSemester", title: "Total Paid for Current Semester" },
      { id: "balance", title: "Balance" },
      { id: "aliDiscountAmount", title: "Ali Discount Amount" },
      { id: "discountApplied", title: "Discount Applied to Columns" },
      { id: "period2", title: "Period 2" },
    ],
  },
  {
    tuitionFeesPerSemester: [
      { id: "preparatoryDepartment", title: "Preparatory Department" },
      { id: "costSemester1", title: "Cost of 1st Semester" },
      { id: "costSemester2", title: "Cost of 2nd Semester" },
      { id: "costSemester3", title: "Cost of 3rd Semester" },
      { id: "costSemester4", title: "Cost of 4th Semester" },
      { id: "costSemester5", title: "Cost of 5th Semester" },
      { id: "costSemester6", title: "Cost of 6th Semester" },
      { id: "costSemester7", title: "Cost of 7th Semester" },
      { id: "costSemester8", title: "Cost of 8th Semester" },
      { id: "costSemester9", title: "Cost of 9th Semester" },
      { id: "costSemester10", title: "Cost of 10th Semester" },
      { id: "costSemester11", title: "Cost of 11th Semester" },
      { id: "costSemester12", title: "Cost of 12th Semester" },
    ],
  },
  {
    pgPhdFees: [
      { id: "pgPhdCostSemester1", title: "PG / PhD Cost per Semester 1" },
      { id: "pgPhdCostSemester2", title: "PG / PhD Cost per Semester 2" },
      { id: "pgPhdCostSemester3", title: "PG / PhD Cost per Semester 3" },
      { id: "pgPhdCostSemester4", title: "PG / PhD Cost per Semester 4" },
      { id: "pgPhdCostSemester5", title: "PG / PhD Cost per Semester 5" },
      { id: "pgPhdCostSemester6", title: "PG / PhD Cost per Semester 6" },
    ],
  },
  {
    additionalExpenses: [
      { id: "otherExpenses", title: "Other Expenses" },
      { id: "transfer", title: "Transfer" },
      { id: "admissionFee", title: "Admission Fee" },
      { id: "temporaryResidencePermission", title: "Temporary Residence Permission" },
      { id: "hostelAccommodation", title: "Hostel Accommodation" },
      { id: "registrationInsurance", title: "Registration / Insurance" },
      { id: "nostrification", title: "Nostrification" },
    ],
  },
  {
    payments: [
      { id: "refundedToStudent", title: "Refunded to Student" },
      { id: "appliedForAnotherStudent", title: "Applied as Payment for Another Student" },
      { id: "paymentFromAnotherStudent", title: "Payment Applied from Another Student" },
      { id: "agentCommissionPayment", title: "Applied for Agent’s Commission" },
      { id: "totalPaid", title: "Total Paid" },
      { id: "convertedCurrency", title: "Converted to Invoice Currency" },
      { id: "exchangeRate", title: "Exchange Rate" },
      { id: "paymentUsd", title: "Payment USD" },
      { id: "paymentEur", title: "Payment EUR" },
      { id: "paymentUah", title: "Payment UAH" },
      { id: "paymentDate", title: "Payment Date" },
      { id: "accountName", title: "Account Name" },
      { id: "status", title: "Status" },
      { id: "agentCommission", title: "Agent’s Commission" },
    ],
  },
  {
    extraCosts: [
      { id: "nostrificationExtra", title: "Nostrification" },
      { id: "additionalExpensesExtra", title: "Additional Expenses" },
      { id: "accommodation", title: "Accommodation" },
      { id: "passportTranslation", title: "Passport Translation" },
      { id: "medicalCheck", title: "Medical Check" },
      { id: "insurance", title: "Insurance" },
      { id: "residencePermitExtra", title: "Residence Permit" },
      { id: "registration", title: "Registration" },
      { id: "insuranceValidUntil", title: "Insurance Valid Until" },
      { id: "paidInCash", title: "Paid in Cash to University" },
    ],
  },
];

export const OfficeAccountingTableBody: Section<BodyColumn>[][] = [
  [
    {
      studentInfo: [
        // , dateUpdated: '01.01.1988'
        { id: "id", value: "00.2680 1" },
        { id: "fullNameEn", value: "NDAGIJIMANA FLORIBERI 1" },
        { id: "country", value: "Rwanda" },
        { id: "dateOfBirth", value: "01.01.1988" },
        { id: "passportNumber", value: "PC768552" },
        { id: "passportExpiryDate", value: "13.02.2034" },
        { id: "studentPhone", value: "+38093016780" },
        { id: "studentEmail", value: "fggfuhkj@gmail.com" },
        { id: "managerEmail", value: "ieu@gmail.com" },
        { id: "agentEmail", value: "fcdhfj@gmail.com" },
        { id: "fieldOfStudy", value: "Pharmacy on campus" },
        { id: "admissionSemester", value: "PD" },
        { id: "intake", value: "January 2022" },
        { id: "currentSemester", value: "PD" },
        { id: "expelled", value: "" },
        { id: "groupNumber", value: "№07 П, №45 ЕП, №56PG" },
        { id: "residencePermit", value: "" },
        { id: "residencePermitExpiry", value: "04.08.2028" },
      ],
    },
    {
      documents: [
        { id: "preparatoryOrder", value: "№О1-ПЗ 20/02/22" },
        { id: "preparatoryExpel", value: "№О1-ПA 21/02/22" },
        { id: "mainCourseEnrollmentOrder", value: "№О1-ПЗ 3/04/23" },
        { id: "mainCourseExpel", value: "№О4-ПЗ 20/02/25" },
      ],
    },
    {
      invoice: [
        { id: "invoiceNumberDate", value: "03-02/25, 34-01/25, NONE" },
        { id: "invoice", value: "6100, 1200, 5400" },
        { id: "invoiceCurrency", value: "USD, EUR, UAH" },
        { id: "invoiceDurationYears", value: "3,5" },
        { id: "period1", value: "" },
      ],
    },
    {
      finance: [
        { id: "totalFeeAccrued", value: "$2 750,00" },
        { id: "totalPaidCurrentSemester", value: "$0,00" },
        { id: "balance", value: "$2 750,00" },
        { id: "aliDiscountAmount", value: "" },
        { id: "discountApplied", value: "" },
        { id: "period2", value: "" },
      ],
    },
    {
      tuitionFeesPerSemester: [
        { id: "preparatoryDepartment", value: "$800,00" },
        { id: "costSemester1", value: "" },
        { id: "costSemester2", value: "$2 150,00" },
        { id: "costSemester3", value: "$3 000,00" },
        { id: "costSemester4", value: "$2 150,00" },
        { id: "costSemester5", value: "$2 150,00" },
        { id: "costSemester6", value: "$2 150,00" },
        { id: "costSemester7", value: "$2 150,00" },
        { id: "costSemester8", value: "$498,00" },
        { id: "costSemester9", value: "$400,00" },
        { id: "costSemester10", value: "$2 150,00" },
        { id: "costSemester11", value: "$2 150,00" },
        { id: "costSemester12", value: "$2 150,00" },
      ],
    },
    {
      pgPhdFees: [
        { id: "pgPhdCostSemester1", value: "" },
        { id: "pgPhdCostSemester2", value: "" },
        { id: "pgPhdCostSemester3", value: "" },
        { id: "pgPhdCostSemester4", value: "" },
        { id: "pgPhdCostSemester5", value: "" },
        { id: "pgPhdCostSemester6", value: "" },
      ],
    },
    {
      additionalExpenses: [
        { id: "otherExpenses", value: "$1 600,00" },
        { id: "transfer", value: "$350,00" },
        { id: "admissionFee", value: "" },
        { id: "temporaryResidencePermission", value: "" },
        { id: "hostelAccommodation", value: "" },
        { id: "registrationInsurance", value: "" },
        { id: "nostrification", value: "" },
      ],
    },
    {
      payments: [
        { id: "refundedToStudent", value: "" },
        { id: "appliedForAnotherStudent", value: "" },
        { id: "paymentFromAnotherStudent", value: "" },
        { id: "agentCommissionPayment", value: "" },
        { id: "totalPaid", value: "" },
        { id: "convertedCurrency", value: "$3 000,00" },
        { id: "exchangeRate", value: "" },
        { id: "paymentUsd", value: "$3 000,00" },
        { id: "paymentEur", value: "" },
        { id: "paymentUah", value: "" },
        { id: "paymentDate", value: "" },
        { id: "accountName", value: "" },
        { id: "status", value: "" },
        { id: "agentCommission", value: "" },
      ],
    },
    {
      extraCosts: [
        { id: "nostrificationExtra", value: "" },
        { id: "additionalExpensesExtra", value: "" },
        { id: "accommodation", value: "" },
        { id: "passportTranslation", value: "" },
        { id: "medicalCheck", value: "" },
        { id: "insurance", value: "" },
        { id: "residencePermitExtra", value: "" },
        { id: "registration", value: "" },
        { id: "insuranceValidUntil", value: "" },
        { id: "paidInCash", value: "" },
      ],
    },
  ],
  [
    {
      studentInfo: [
        { id: "id", value: "00.2680 2" },
        { id: "fullNameEn", value: "NDAGIJIMANA FLORIBERI 2" },
        { id: "country", value: "Rwanda" },
        { id: "dateOfBirth", value: "01.01.1988" },
        { id: "passportNumber", value: "PC768552" },
        { id: "passportExpiryDate", value: "13.02.2034" },
        { id: "studentPhone", value: "+38093016780" },
        { id: "studentEmail", value: "fggfuhkj@gmail.com" },
        { id: "managerEmail", value: "ieu@gmail.com" },
        { id: "agentEmail", value: "fcdhfj@gmail.com" },
        { id: "fieldOfStudy", value: "Pharmacy on campus" },
        { id: "admissionSemester", value: "PD" },
        { id: "intake", value: "January 2022" },
        { id: "currentSemester", value: "PD" },
        { id: "expelled", value: "" },
        { id: "groupNumber", value: "№07 П, №45 ЕП, №56PG" },
        { id: "residencePermit", value: "" },
        { id: "residencePermitExpiry", value: "04.08.2028" },
      ],
    },
    {
      documents: [
        { id: "preparatoryOrder", value: "№О1-ПЗ 20/02/22" },
        { id: "preparatoryExpel", value: "№О1-ПA 21/02/22" },
        { id: "mainCourseEnrollmentOrder", value: "№О1-ПЗ 3/04/23" },
        { id: "mainCourseExpel", value: "№О4-ПЗ 20/02/25" },
      ],
    },
    {
      invoice: [
        { id: "invoiceNumberDate", value: "03-02/25, 34-01/25, NONE" },
        { id: "invoice", value: "6100, 1200, 5400" },
        { id: "invoiceCurrency", value: "USD, EUR, UAH" },
        { id: "invoiceDurationYears", value: "3,5" },
        { id: "period1", value: "" },
      ],
    },
    {
      finance: [
        { id: "totalFeeAccrued", value: "$2 750,00" },
        { id: "totalPaidCurrentSemester", value: "$0,00" },
        { id: "balance", value: "$2 750,00" },
        { id: "aliDiscountAmount", value: "" },
        { id: "discountApplied", value: "" },
        { id: "period2", value: "" },
      ],
    },
    {
      tuitionFeesPerSemester: [
        { id: "preparatoryDepartment", value: "$800,00" },
        { id: "costSemester1", value: "" },
        { id: "costSemester2", value: "$2 150,00" },
        { id: "costSemester3", value: "$3 000,00" },
        { id: "costSemester4", value: "$2 150,00" },
        { id: "costSemester5", value: "$2 150,00" },
        { id: "costSemester6", value: "$2 150,00" },
        { id: "costSemester7", value: "$2 150,00" },
        { id: "costSemester8", value: "$498,00" },
        { id: "costSemester9", value: "$400,00" },
        { id: "costSemester10", value: "$2 150,00" },
        { id: "costSemester11", value: "$2 150,00" },
        { id: "costSemester12", value: "$2 150,00" },
      ],
    },
    {
      pgPhdFees: [
        { id: "pgPhdCostSemester1", value: "" },
        { id: "pgPhdCostSemester2", value: "" },
        { id: "pgPhdCostSemester3", value: "" },
        { id: "pgPhdCostSemester4", value: "" },
        { id: "pgPhdCostSemester5", value: "" },
        { id: "pgPhdCostSemester6", value: "" },
      ],
    },
    {
      additionalExpenses: [
        { id: "otherExpenses", value: "$1 600,00" },
        { id: "transfer", value: "$350,00" },
        { id: "admissionFee", value: "" },
        { id: "temporaryResidencePermission", value: "" },
        { id: "hostelAccommodation", value: "" },
        { id: "registrationInsurance", value: "" },
        { id: "nostrification", value: "" },
      ],
    },
    {
      payments: [
        { id: "refundedToStudent", value: "" },
        { id: "appliedForAnotherStudent", value: "" },
        { id: "paymentFromAnotherStudent", value: "" },
        { id: "agentCommissionPayment", value: "" },
        { id: "totalPaid", value: "" },
        { id: "convertedCurrency", value: "$3 000,00" },
        { id: "exchangeRate", value: "" },
        { id: "paymentUsd", value: "$3 000,00" },
        { id: "paymentEur", value: "" },
        { id: "paymentUah", value: "" },
        { id: "paymentDate", value: "" },
        { id: "accountName", value: "" },
        { id: "status", value: "" },
        { id: "agentCommission", value: "" },
      ],
    },
    {
      extraCosts: [
        { id: "nostrificationExtra", value: "" },
        { id: "additionalExpensesExtra", value: "" },
        { id: "accommodation", value: "" },
        { id: "passportTranslation", value: "" },
        { id: "medicalCheck", value: "" },
        { id: "insurance", value: "" },
        { id: "residencePermitExtra", value: "" },
        { id: "registration", value: "" },
        { id: "insuranceValidUntil", value: "" },
        { id: "paidInCash", value: "" },
      ],
    },
  ],
  [
    {
      studentInfo: [
        { id: "id", value: "00.2680 3" },
        { id: "fullNameEn", value: "NDAGIJIMANA FLORIBERI 3" },
        { id: "country", value: "Rwanda" },
        { id: "dateOfBirth", value: "01.01.1988" },
        { id: "passportNumber", value: "PC768552" },
        { id: "passportExpiryDate", value: "13.02.2034" },
        { id: "studentPhone", value: "+38093016780" },
        { id: "studentEmail", value: "fggfuhkj@gmail.com" },
        { id: "managerEmail", value: "ieu@gmail.com" },
        { id: "agentEmail", value: "fcdhfj@gmail.com" },
        { id: "fieldOfStudy", value: "Pharmacy on campus" },
        { id: "admissionSemester", value: "PD" },
        { id: "intake", value: "January 2022" },
        { id: "currentSemester", value: "PD" },
        { id: "expelled", value: "" },
        { id: "groupNumber", value: "№07 П, №45 ЕП, №56PG" },
        { id: "residencePermit", value: "" },
        { id: "residencePermitExpiry", value: "04.08.2028" },
      ],
    },
    {
      documents: [
        { id: "preparatoryOrder", value: "№О1-ПЗ 20/02/22" },
        { id: "preparatoryExpel", value: "№О1-ПA 21/02/22" },
        { id: "mainCourseEnrollmentOrder", value: "№О1-ПЗ 3/04/23" },
        { id: "mainCourseExpel", value: "№О4-ПЗ 20/02/25" },
      ],
    },
    {
      invoice: [
        { id: "invoiceNumberDate", value: "03-02/25, 34-01/25, NONE" },
        { id: "invoice", value: "6100, 1200, 5400" },
        { id: "invoiceCurrency", value: "USD, EUR, UAH" },
        { id: "invoiceDurationYears", value: "3,5" },
        { id: "period1", value: "" },
      ],
    },
    {
      finance: [
        { id: "totalFeeAccrued", value: "$2 750,00" },
        { id: "totalPaidCurrentSemester", value: "$0,00" },
        { id: "balance", value: "$2 750,00" },
        { id: "aliDiscountAmount", value: "" },
        { id: "discountApplied", value: "" },
        { id: "period2", value: "" },
      ],
    },
    {
      tuitionFeesPerSemester: [
        { id: "preparatoryDepartment", value: "$800,00" },
        { id: "costSemester1", value: "" },
        { id: "costSemester2", value: "$2 150,00" },
        { id: "costSemester3", value: "$3 000,00" },
        { id: "costSemester4", value: "$2 150,00" },
        { id: "costSemester5", value: "$2 150,00" },
        { id: "costSemester6", value: "$2 150,00" },
        { id: "costSemester7", value: "$2 150,00" },
        { id: "costSemester8", value: "$498,00" },
        { id: "costSemester9", value: "$400,00" },
        { id: "costSemester10", value: "$2 150,00" },
        { id: "costSemester11", value: "$2 150,00" },
        { id: "costSemester12", value: "$2 150,00" },
      ],
    },
    {
      pgPhdFees: [
        { id: "pgPhdCostSemester1", value: "" },
        { id: "pgPhdCostSemester2", value: "" },
        { id: "pgPhdCostSemester3", value: "" },
        { id: "pgPhdCostSemester4", value: "" },
        { id: "pgPhdCostSemester5", value: "" },
        { id: "pgPhdCostSemester6", value: "" },
      ],
    },
    {
      additionalExpenses: [
        { id: "otherExpenses", value: "$1 600,00" },
        { id: "transfer", value: "$350,00" },
        { id: "admissionFee", value: "" },
        { id: "temporaryResidencePermission", value: "" },
        { id: "hostelAccommodation", value: "" },
        { id: "registrationInsurance", value: "" },
        { id: "nostrification", value: "" },
      ],
    },
    {
      payments: [
        { id: "refundedToStudent", value: "" },
        { id: "appliedForAnotherStudent", value: "" },
        { id: "paymentFromAnotherStudent", value: "" },
        { id: "agentCommissionPayment", value: "" },
        { id: "totalPaid", value: "" },
        { id: "convertedCurrency", value: "$3 000,00" },
        { id: "exchangeRate", value: "" },
        { id: "paymentUsd", value: "$3 000,00" },
        { id: "paymentEur", value: "" },
        { id: "paymentUah", value: "" },
        { id: "paymentDate", value: "" },
        { id: "accountName", value: "" },
        { id: "status", value: "" },
        { id: "agentCommission", value: "" },
      ],
    },
    {
      extraCosts: [
        { id: "nostrificationExtra", value: "" },
        { id: "additionalExpensesExtra", value: "" },
        { id: "accommodation", value: "" },
        { id: "passportTranslation", value: "" },
        { id: "medicalCheck", value: "" },
        { id: "insurance", value: "" },
        { id: "residencePermitExtra", value: "" },
        { id: "registration", value: "" },
        { id: "insuranceValidUntil", value: "" },
        { id: "paidInCash", value: "" },
      ],
    },
  ],
];
